import { formatFileSize } from "helpers";

interface DisplayFileSizeProps {
  value?: number;
}

export const DisplayFileSize: React.FC<DisplayFileSizeProps> = ({ value }) => {
  if (value == undefined) {
    return "-";
  }

  return <>{formatFileSize(value)}</>;
};
